import { axios } from '../util/axios'

const urlAuhorize = 'https://auth.olx.com.br/oauth/v2/authorize'

export const grantAccessToUser = accessData => {
  try {
    const data = {
      decision: 'Aceitar',
      ...accessData,
    }
    return axios.post(urlAuhorize, data, {
      withCredentials: true,
    })
  } catch (error) {
    console.error(error)
  }
}

export const declineAccessToUser = accessData => {
  try {
    const data = {
      decision: 'Cancelar',
      ...accessData,
    }
    return axios.post(urlAuhorize, data, {
      withCredentials: true,
    })
  } catch (error) {
    console.error(error)
  }
}

export const getClientNameById = async (clientId, accessData) => {
  try {
    const response = await axios.get(`https://apigw.olx.com.br/oauth/clients/${clientId}/name`, {
      params: { ...accessData },
    })
    return response.data[0].name
  } catch (error) {
    console.error(error)
  }
}
